<ng-container *transloco="let t">
    <mat-card class="altair-card subdomains-card mb-25 border-radius bg-white border-none d-block"
        [class.component-dark-theme]="themeService.isDark()" [class.rtl-enabled]="themeService.isRTLEnabled()">
        <mat-card-header>
            <mat-card-title>
                <button mat-raised-button color="altair" (click)="exportTOExcel()">{{t('export-as-excel')}}</button>
            </mat-card-title>
             <mat-card-subtitle>
                <form class="search-box position-relative">
                    <i class="material-symbols-outlined">
                        search
                    </i>
                    <input matInput class="input-search d-block w-100 border-none outline-0"
                        placeholder="{{t('search')}} {{t('subdomain')}}..." (keyup)="applyFilter($event)"
                        (keydown.enter)="onKeydown($event)" #input>
                </form>
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <div class="subdomains-table">
                <div #TABLE>
                    <table mat-table [dataSource]="dataSource" matSort matSortActive="contentLength" matSortDirection="desc" matSortDisableClear style="table-layout: fixed">

                        <!-- subdomain Column -->
                        <ng-container matColumnDef="subdomain">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header style="max-width:30%;">
                                {{t('subdomain')}}
                            </th>
                            <td mat-cell *matCellDef="let element" style="max-width:30%;">
                                <div>
                                    <a href="{{element.http_url ? element.http_url : 'https://' + element.name}}" class="text-primary" target="_blank"><span id="subdomain-{{element.id}}">
                                        {{element.name}}
                                    </span></a>
                                </div>
                                @if (element.endpoint_count) {
                                <span class="badge text-soft-primary" title="Endpoints">{{element.endpoint_count}} <i class=" fas fa-link"></i></span>
                                }

                                @if (element.technologies){
                                <div class="wrap">
                                    @for (item of element.technologies; track item) {
                                    <span data-toggle="tooltip" title="Technology" class='badge text-soft-primary mt-1 me-1'>{{item.name}}</span>
                                    }
                                </div>
                                }

                                @if(element.is_interesting) {
                                <div><span class='me-1 badge text-soft-danger' data-toggle="tooltip" data-placement="top" title="Interesting Subdomain">Interesting</span></div>
                                }

                                @if (element.content_type) {
                                <div><span class='mt-1 badge text-soft-warning bs-tooltip' title="Content Type">{{element.content_type}}</span></div>
                                }

                                @if (element.webserver) {
                                <div><span class='mt-1 badge text-soft-info bs-tooltip' title="Web Server">{{element.webserver}}</span></div>
                                }
                            </td>
                        </ng-container>

                        <!-- status Column -->
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header style="max-width:10%; text-align:center">
                                {{t('status')}}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                @if (element.http_status >= 200 && element.http_status < 300) {
                                <span class="badge badge-pills bg-success mt-1">{{element.http_status}}</span>
			                    }
			                    @else if (element.http_status >= 300 && element.http_status < 400) {
                                <span class="badge badge-pills bg-warning mt-1">{{element.http_status}}</span>
                                }
                                @else if (element.http_status > 0) {
                                <span class="badge badge-pills bg-danger mt-1">{{element.http_status}}</span>
                                }
                            </td>
                        </ng-container>

                        <!-- title Column -->
                        <ng-container matColumnDef="title">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header style="max-width:20%; text-align:center">
                                {{t('title')}}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{element.page_title}}
                            </td>
                        </ng-container>

                        <!-- ip Column -->
                        <ng-container matColumnDef="ip">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header style="max-width:20%; text-align:center">
                                {{t('ip')}}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                @for (item of element.ip_addresses; track item) {
                                <span class="badge text-soft-info info">{{item.address}}</span>
                                }
                            </td>
                        </ng-container>

                        <!-- contentLength Column -->
                        <ng-container matColumnDef="contentLength">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header style="max-width:10%; text-align:center">
                                {{t('content-length')}}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{element.content_length}}
                            </td>
                        </ng-container>

                        <!-- responseTime Column -->
                        <ng-container matColumnDef="responseTime">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header style="max-width:10%; text-align:center">
                                {{t('response-time')}}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span class="text-success">{{element.response_time | number}}</span>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    </table>
                </div>
                <mat-paginator [pageSizeOptions]="pageSizes" showFirstLastButtons></mat-paginator>
            </div>
        </mat-card-content>
    </mat-card>
</ng-container>
